import appCommuterPackage from "../../views/appPlans/commuterPackage.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("package", {
    url: "package/:id",
    parent: "app",
    views: {
      view: {
        template: appCommuterPackage,
      },
    },
    reloadOnSearch: false,
    data: { title: "CommuterPackage" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/commuterPackage/commuterPackage.urls.js